export default "__VITE_ASSET__CFBaOtse__"